import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, catchError, finalize, map, tap, throwError } from 'rxjs';
import { GetLanguage } from '../models/language.model';
import { localizeData } from './_localizeData';
import { API_CONFIG } from './api.config';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private isLoading: boolean = false;

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  getlanguages(): Observable<GetLanguage[]> {
    const lang = this.translate.currentLang || this.translate.getDefaultLang();
    const url = `${API_CONFIG.endpoint}/languages?populate[localizations]=true`;
    this.isLoading = true;

    return this.http.get<{ data: GetLanguage[] }>(url).pipe(
      map((response) => response.data),
      tap((languages) => {
        localizeData(languages, lang);
      }),
      finalize(() => {
        this.isLoading = false;
      }),
      catchError((error) => {
        this.toastr.error(this.translate.instant('LANGUAGES_LOADING_ERROR'));
        return throwError(() => new Error('Erreur lors du chargement des langues'));
      })
    );
  }

  getLanguageLevels(): Observable<any> {
    const lang = this.translate.currentLang || this.translate.getDefaultLang();
    const url = `${API_CONFIG.endpoint}/language-levels?populate[localizations]=true`;

    return this.http.get<{ data: any[] }>(url).pipe(
      map((response) => response.data),
      tap((levels) => {
        localizeData(levels, lang);
      }),
      catchError((error) => {
        this.toastr.error(this.translate.instant('LANGUAGE_LEVELS_LOADING_ERROR'));
        return throwError(
          () => new Error('Erreur lors du chargement des niveaux de langues')
        );
      })
    );
  }

  getLoadingStatus(): boolean {
    return this.isLoading;
  }
}
